import React from "react";
import "./StatsBoxContainer.scss";
import CountUp from "react-countup";

interface StatsBoxProps {
  name: string;
  value: string | number | null;
  valueColor?: string;
}

const StatsBox: React.FC<StatsBoxProps> = ({
  name,
  value,
  valueColor = "#000",
}) => {
  // Check if the value is a string that contains non-numeric characters
  const isFormattedString = typeof value === "string" && /[a-zA-Z]/.test(value);

  return (
    <div className="stats-box">
      <div className="stats-name">{name}</div>
      <div
        className="stats-value"
        style={{ color: valueColor, transition: "all 0.5s ease-in-out" }}
      >
        {isFormattedString ? (
          value
        ) : (
          <CountUp
            start={0}
            end={
              typeof value === "string" ? parseFloat(value) || 0 : value ?? 0
            }
            duration={0.5}
            separator={","}
          />
        )}
      </div>
    </div>
  );
};

const StatsBoxSkeleton: React.FC = () => {
  return (
    <div className="stats-box">
      <div className="stats-name animate-pulse bg-gray-200 h-4 rounded w-20"></div>
      <div className="stats-value animate-pulse bg-gray-200 h-8 rounded w-16 mt-2"></div>
    </div>
  );
};

const StatsBoxContainer: React.FC<{
  stats: StatsBoxProps[];
  loading?: boolean;
}> = ({ stats, loading = false }) => {
  return (
    <div className="stats-box-container">
      {loading
        ? // Show skeleton loaders when loading
          Array.from({ length: stats.length || 4 }).map((_, index) => (
            <StatsBoxSkeleton key={`skeleton-${index}`} />
          ))
        : // Show actual stats when not loading
          stats.map((stat, index) => <StatsBox key={index} {...stat} />)}
    </div>
  );
};

export default StatsBoxContainer;
